import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import Constants from '../../../definitions/constants';
import LocaleTooling from '../../../tooling/localeTooling';

import Button from '../common/inputs/button';
import Select from '../common/inputs/select';
import FetchAutocompleteList from '../common/inputs/fetchAutocompleteList';
import SelectWithTextBoxInput from '../common/inputs/selectWithTextBoxInput';

const CalculationUnitsFilter = props => {
  const {
    onChangeFilter,
    filterValues,
    groupsData,    
    modelsData,
    subModelsData,
    calculationUnitsData,
    calculationUnitsFetchAction,
    calculationUnitsLoading
  } = props;
  let modelAllSelectArray = []
  if(subModelsData && subModelsData.length > 0) {
    modelAllSelectArray = [{id: "all", name: intl.formatMessage({id:"periodAdmin.calculationUnitFilter.all"})}];
  }    
  return (
    <div className="calculation_section calculation_units_filter_wrapper">
      <h3>{LocaleTooling.getCalculationUnitContextLocale(<FormattedMessage id="periodAdmin.calculationUnitsFiltertitle"/>)}</h3>
      <Select 
        value={filterValues["filterGroup"]}
        onChange={onChangeFilter}
        labelLocale={<FormattedMessage id="periodAdmin.calculationUnitFilterGroupsLabel"/>}
        options={InterfaceTooling.getSelectArrayFromArrayOfObjects(groupsData, "id", "name")}
        data-path="filterGroup"
      />
      <Select 
        value={filterValues["criteria"]}
        onChange={onChangeFilter}
        labelLocale={<FormattedMessage id="periodAdmin.calculationUnitFilterLabel"/>}
        options={InterfaceTooling.getSelectArray("calculationFilters.calculationUnitFilter", "periodAdmin.calculationUnitFilter", false)}
        data-path="criteria"
      />
      {(filterValues["criteria"]!="" && filterValues["criteria"]!=Constants.calculationFilters.calculationUnitFilter.ALL) && (
        <FetchAutocompleteList        
          values={filterValues["calculationUnitsSelected"]}
          onChange={onChangeFilter}
          addSelectLocale={LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({id:"periodAdmin.calculationUnitFilterFinderLabel"}))}
          options={InterfaceTooling.getSelectArrayFromArrayOfObjects(calculationUnitsData, "id", "name", false)}
          valueAccesor={"id"}
          labelAccesor={"name"}
          fetchListAction={calculationUnitsFetchAction}
          loadingFetch={calculationUnitsLoading}
          data-path="calculationUnitsSelected"
        />
      )}
      {(subModelsData && subModelsData.length > 0) && (
        <label className="form_info">
          <FormattedMessage 
            id={"periodAdmin.calculationUnitFilterModelsHelp"}
          />
        </label>
      )}
      <SelectWithTextBoxInput
        values={filterValues["filterPolynomial"]}
        onClickOption={onChangeFilter}
        addSelectLocale={ intl.formatMessage({ id: "periodAdmin.calculationUnitFilterModelsLabel" })}
        options={InterfaceTooling.getSelectArrayFromArrayOfObjects(modelAllSelectArray.concat(modelsData), "id", "name", false)}
        onClearTextCallback={onChangeFilter}
        data-path={"filterPolynomial"}
        allowDisplayOptionsButton={true}
      />
      {(subModelsData && subModelsData.length > 0) && (
        <SelectWithTextBoxInput
          values={filterValues["filterPolynomialSubModel"]}
          onClickOption={onChangeFilter}
          addSelectLocale={ intl.formatMessage({ id: "periodAdmin.calculationUnitFilterSubModelsLabel" })}
          options={InterfaceTooling.getSelectArrayFromArrayOfObjects(modelAllSelectArray.concat(subModelsData), "id", "name", false)}
          onClearTextCallback={onChangeFilter}
          data-path={"filterPolynomialSubModel"}
          allowDisplayOptionsButton={true}
        />
      )}
    </div>
  );
};

export default CalculationUnitsFilter;



// WEBPACK FOOTER //
// ./source/client/components/periodAdmin/calculationUnitsFilter.jsx